module.exports = __webpack_public_path__ + "static/media/Mission_mobile2_EN.98b55a99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mission_mobile2_EN.png
// module id = 1064
// module chunks = 0